export enum PassOrFailEnum {
    Pass = 'P',
    Fail = 'F',
}
